/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FieldPermission,
    FieldPermissionFromJSON,
    FieldPermissionFromJSONTyped,
    FieldPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface FieldPermissionIdAndLabel
 */
export interface FieldPermissionIdAndLabel {
    /**
     * 
     * @type {FieldPermission}
     * @memberof FieldPermissionIdAndLabel
     */
    id?: FieldPermission;
    /**
     * 
     * @type {string}
     * @memberof FieldPermissionIdAndLabel
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldPermissionIdAndLabel
     */
    effective?: boolean;
}

export function FieldPermissionIdAndLabelFromJSON(json: any): FieldPermissionIdAndLabel {
    return FieldPermissionIdAndLabelFromJSONTyped(json, false);
}

export function FieldPermissionIdAndLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldPermissionIdAndLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : FieldPermissionFromJSON(json['id']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
    };
}

export function FieldPermissionIdAndLabelToJSON(value?: FieldPermissionIdAndLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': FieldPermissionToJSON(value.id),
        'label': value.label,
        'effective': value.effective,
    };
}


